import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import {
    listBanners,
    deleteBanner,
    listBannerDetails,
    allBanners
} from "../actions/bannerActions";
import { BANNER_CREATE_RESET } from "../constants/bannerConstants";
import Paginate from "../components/Paginate";

const BannersListScreen = () => {
    const history = useHistory();
    const { pageNumber } = useParams() || 1;
    const dispatch = useDispatch();

    const bannerList = useSelector((state) => state.bannerList);
    const { loading, error, banners, pages, page } = bannerList;

    const bannerDelete = useSelector((state) => state.bannerDelete);
    const {
        loading: loadingDelete,
        error: errorDelete,
        success: successDelete,
    } = bannerDelete;

    const bannerCreate = useSelector((state) => state.bannerCreate);
    const {
        loading: loadingCreate,
        error: errorCreate,
        success: successCreate,
        banner: createdBanner,
    } = bannerCreate;

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        dispatch({ type: BANNER_CREATE_RESET });
        dispatch(allBanners());
        if (!userInfo || !userInfo.isAdmin) {
            history.push("/login");
        }
        if (successCreate) {
            history.push(`/admin/banner/${createdBanner._id}/edit`);
            
        } else {
            dispatch(listBanners("", pageNumber));
        }
    }, [
        dispatch,
        history,
        userInfo,
        successDelete,
        successCreate,
        createdBanner,
        pageNumber,
    ]);

    const deleteHandler = (id) => {
        if (window.confirm("Are you sure you want to delete this banner?")) {
            dispatch(deleteBanner(id));
        }
    };

    return (
        <>
            <Row className="align-items-center">
                <Col>
                    <h1>Banners</h1>
                </Col>
                <Col className="text-right">
                <LinkContainer to={`/admin/banner/create`}>                  
                    <Button className="my-3" 
                    >
                        <i className="fas fa-plus"></i> Create Banner
                    </Button>
                  </LinkContainer>
                </Col>
            </Row>
            {loadingDelete && <Loader />}
            {errorDelete && <Message variant="danger">{errorDelete}</Message>}
            {loadingCreate && <Loader />}
            {errorCreate && <Message variant="danger">{errorCreate}</Message>}
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">{error}</Message>
            ) : (
                <>
                    <Table
                        striped
                        bordered
                        hover
                        responsive
                        className="table-sm"
                    >
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>NAME</th>
                                <th>Link</th>
                                <th>SHOW BANNER</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {banners.map((banner) => (
                                <tr key={banner._id}>
                                    <td>{banner._id}</td>
                                    <td>{banner.name}</td>
                                    <td>{banner.bannerLink}</td>
                                    <td>{banner.showBanner?'Yes':'No'}</td>
                                    <td>
                                        <LinkContainer
                                            to={`/admin/banner/${banner._id}/edit`}
                                        >
                                            <Button
                                            onClick={() =>
                                                dispatch(
                                                    listBannerDetails(
                                                        banner._id
                                                    )
                                                )
                                            }
                                                variant="light"
                                                className="btn-sm"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button>
                                        </LinkContainer>
                                        <Button
                                            variant="danger"
                                            className="btn-sm"
                                            onClick={() =>
                                                deleteHandler(banner._id)
                                            }
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Paginate pages={pages} page={page} isAdmin={true} />
                </>
            )}
        </>
    );
};

export default BannersListScreen;
